module.exports = __webpack_public_path__ + "static/media/NitheshPadival1.d21c33ac.svg";